import { BaseAuthService } from '#instruments/services/BaseAuthService';

export class AuthService extends BaseAuthService {}
